import { EventCatalogFromKeys, EventType } from "../../types";

export const AdminCaseworkersEventKeys = {
  ADMIN_CASEWORKER_SEND_MESSAGE_BUTTON_CLICK:
    "admin-caseworker-send-message-button-click",
  ADMIN_CASEWORKER_TABLE_FILTER_AREAS: "admin-caseworker-table-filter-areas",
  ADMIN_CASEWORKER_TABLE_FILTER_CREATED_AT:
    "admin-caseworker-table-filter-created-at",
  ADMIN_CASEWORKER_TABLE_FILTER_EMAIL: "admin-caseworker-table-filter-email",
  ADMIN_CASEWORKER_TABLE_FILTER_NAME: "admin-caseworker-table-filter-name",
  ADMIN_CASEWORKER_TABLE_FILTER_PHONE: "admin-caseworker-table-filter-phone",
  ADMIN_CASEWORKER_TABLE_SEARCH: "admin-caseworker-table-search",
  ADMIN_CASEWORKER_VIEW_NEEDS_BUTTON_CLICK:
    "admin-caseworker-view-needs-button-click",
  ADMIN_CASEWORKERS_PAGE_VIEW: "admin-caseworkers-page-view",
} as const;

export const AdminCaseworkersEventCatalog: EventCatalogFromKeys<
  typeof AdminCaseworkersEventKeys
> = {
  [AdminCaseworkersEventKeys.ADMIN_CASEWORKER_SEND_MESSAGE_BUTTON_CLICK]: {
    description: "Admin clicked the send message button for a caseworker",
    eventType: EventType.BUTTON_CLICK,
    id: AdminCaseworkersEventKeys.ADMIN_CASEWORKER_SEND_MESSAGE_BUTTON_CLICK,
  },
  [AdminCaseworkersEventKeys.ADMIN_CASEWORKER_VIEW_NEEDS_BUTTON_CLICK]: {
    description: "Admin clicked the view needs button for a caseworker",
    eventType: EventType.BUTTON_CLICK,
    id: AdminCaseworkersEventKeys.ADMIN_CASEWORKER_VIEW_NEEDS_BUTTON_CLICK,
  },
  [AdminCaseworkersEventKeys.ADMIN_CASEWORKERS_PAGE_VIEW]: {
    description: "Admin viewed the caseworkers management page",
    eventType: EventType.PAGE_VIEW,
    id: AdminCaseworkersEventKeys.ADMIN_CASEWORKERS_PAGE_VIEW,
  },
  [AdminCaseworkersEventKeys.ADMIN_CASEWORKER_TABLE_FILTER_CREATED_AT]: {
    description: "Admin filtered caseworkers by created at",
    eventType: EventType.TABLE_FILTER,
    id: AdminCaseworkersEventKeys.ADMIN_CASEWORKER_TABLE_FILTER_CREATED_AT,
  },
  [AdminCaseworkersEventKeys.ADMIN_CASEWORKER_TABLE_FILTER_EMAIL]: {
    description: "Admin filtered caseworkers by email",
    eventType: EventType.TABLE_FILTER,
    id: AdminCaseworkersEventKeys.ADMIN_CASEWORKER_TABLE_FILTER_EMAIL,
  },
  [AdminCaseworkersEventKeys.ADMIN_CASEWORKER_TABLE_FILTER_NAME]: {
    description: "Admin filtered caseworkers by name",
    eventType: EventType.TABLE_FILTER,
    id: AdminCaseworkersEventKeys.ADMIN_CASEWORKER_TABLE_FILTER_NAME,
  },
  [AdminCaseworkersEventKeys.ADMIN_CASEWORKER_TABLE_FILTER_PHONE]: {
    description: "Admin filtered caseworkers by phone",
    eventType: EventType.TABLE_FILTER,
    id: AdminCaseworkersEventKeys.ADMIN_CASEWORKER_TABLE_FILTER_PHONE,
  },
  [AdminCaseworkersEventKeys.ADMIN_CASEWORKER_TABLE_SEARCH]: {
    description: "Admin searched for a caseworker",
    eventType: EventType.FILTER,
    id: AdminCaseworkersEventKeys.ADMIN_CASEWORKER_TABLE_SEARCH,
  },
  [AdminCaseworkersEventKeys.ADMIN_CASEWORKER_TABLE_FILTER_AREAS]: {
    description: "Admin filtered caseworkers by areas",
    eventType: EventType.TABLE_FILTER,
    id: AdminCaseworkersEventKeys.ADMIN_CASEWORKER_TABLE_FILTER_AREAS,
  },
};
